<template lang="pug">
  .sesame-go-container
    OutSesameGo(
      ref='outSesameGo'
      @confirm='endTask'
      @close='close'
    )
    img.header-img(
      src='https://m.hellobike.com/resource/helloyun/wb15250/c6NgQxz6JM.png?x-oss-process=image/quality,q_80'
      :class="[ \
      isAliMP ? 'header-alimp' : '',\
    ]",
    )
    .header
      .safe-area(
        v-if='isEasyBikeApp'
      )
      .back(
        @click='back'
      )
        img(
          v-if='!isAliMP'
          src='https://m.hellobike.com/resource/helloyun/wb15250/JN8R9844HI.png?x-oss-process=image/quality,q_80'
        )
      .task-status {{ taskStatus }}
      .describe(v-if='isEndTask')
        .surplus 距离任务结束仅剩：
        .time
          .time-box {{ times.day }}
          span 天
          .time-box {{ times.hour }}
          span 时
          .time-box {{ times.min }}
          span 分
          .time-box {{ times.seconds }}
          span 秒
      .describe(v-else)
        .surplus {{ subtitle }}
    .task-info
      .task
        div 承诺任务
        div {{ title }}
      .discount
        div 已享优惠
        div ￥{{ amount }}
      .progressed
        div 任务进度
        div {{ currentProgress }}/{{ totalProgress }}
      .button(
        v-if='isEndTask'
        @click='doTask'
      ) 做任务
    .content
      .title 先享优惠 再做任务
      .promise
        .left
          .info-title
            .info 完成任务
            .icon
          .info-content {{ finishTaskText }}
        .right
          .info-title
            .info 未完成
            .icon
          .info-content {{ failTaskText }}
    .operation
      .item(@click='rule')
        span 活动规则
        img(
          class='symbol'
          src="https://m.hellobike.com/resource/helloyun/wb15250/Y58jUKLN7K.png?x-oss-process=image/quality,q_80"
        )
      .item(
        @click='agreement'
        :class="[ \
      (expire || isEndTask) ? 'bottom-border' : '', \
    ]",
      )
        span 用户协议
        img(
          class='symbol'
          src="https://m.hellobike.com/resource/helloyun/wb15250/Y58jUKLN7K.png?x-oss-process=image/quality,q_80"
        )
      .item(
        v-if='settlementStatus === 0'
        @click='end'
      )
        span 结束任务
        img(
          class='symbol'
          src="https://m.hellobike.com/resource/helloyun/wb15250/Y58jUKLN7K.png?x-oss-process=image/quality,q_80"
        )
</template>

<script>
import { formateTimeStamp } from '@/utils/count-down.js';
import { getZhiMaGoTask } from '@/api/zhima-go.js';
import { TASK_STATUS_ZHIMA_GO } from '@/const/zhima-go.js';
import { getSystemCode } from '@/utils/systemCode';
import { env, Native } from '@hb/NBridge/lib/h5';
import { getTokenAndLocation } from '@/utils/index';
import { isPreRender, commonGoLink } from '@/utils';
import Toast from '@/components/toast';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import OutSesameGo from './components/out-sesame-go.vue';


export default {
  components: {
    OutSesameGo,
  },
  data() {
    return {
      times: {
        day: null,
        hour: null,
        min: null,
        seconds: null,
      },
      title: null,
      finishTaskText: null,
      failTaskText: null,
      zhimaCode: null,
      amount: null,
      failPrice: null,
      primeCost: null,
      settlementStatus: null, // 0待结算 1结算中 2已结算
      taskList: [
        {
          taskStatus: null,
          expireCountdown: null,
          taskUrl: null,
          currentProgress: null,
          totalProgress: null,
        },
      ],
    };
  },
  computed: {
    isEndTask() {
      if (this.taskList.length < 1) return '';
      if (this.taskList[0].taskStatus === TASK_STATUS_ZHIMA_GO.RUNNING
      && this.settlementStatus === 0 && this.taskList[0].expireCountdown > 0) {
        // 做任务按钮曝光埋点
        UBT.moduleExpose({
          pageId: 'platform_zhima',
          categoryId: 'platform',
          moduleId: 'zhimatask_go',
          contentId: 'zhimatask_go',
          exposureTimes: 1,
          businessInfo: {},
        });
        return true;
      }
      return false;
    },
    subtitle() {
      if (this.taskList.length < 1) return '';
      const [data] = this.taskList;
      if (data.taskStatus === TASK_STATUS_ZHIMA_GO.UNFINISHED
      && this.settlementStatus === 2) {
        return `扣回已享优惠金额${this.failPrice}元`;
      }
      if (data.taskStatus === TASK_STATUS_ZHIMA_GO.FINISHED
      && this.settlementStatus === 2) {
        return `恭喜您完成了任务，稳赚了${this.failPrice}元`;
      }
      if (this.settlementStatus === 1) {
        return '系统正在为您结算';
      }
      if (this.expire) {
        return '点击结束任务，发起结算';
      }
      return '';
    },
    taskStatus() {
      if (this.taskList.length < 1) return '';
      const [data] = this.taskList;
      if (this.expire) {
        return '任务已到期,待发起结算';
      }
      if (data.taskStatus === TASK_STATUS_ZHIMA_GO.RUNNING
      && this.settlementStatus === 0 && data.expireCountdown > 0) {
        return '任务进行中';
      }
      if (data.taskStatus === TASK_STATUS_ZHIMA_GO.UNFINISHED
      && this.settlementStatus === 2) {
        return '任务未完成';
      }
      if (data.taskStatus === TASK_STATUS_ZHIMA_GO.FINISHED
      && this.settlementStatus === 2) {
        return '任务已完成';
      }
      if (this.settlementStatus === 1) {
        return '任务结算中';
      }
      return '';
    },
    // 任务到期未结算
    expire() {
      if (this.taskList.length < 1) return false;
      const [data] = this.taskList;
      if (data.expireCountdown < 1 && this.settlementStatus === 0) {
        return true;
      }
      return false;
    },
    currentProgress() {
      if (this.taskList.length < 1) return 0;
      const [data] = this.taskList;
      return data.currentProgress;
    },
    totalProgress() {
      if (this.taskList.length < 1) return 1;
      const [data] = this.taskList;
      return data.totalProgress;
    },
    isAliMP() {
      if (env.isAliMP || env.isAliMPMonitor) {
        return true;
      }
      return false;
    },
    isEasyBikeApp() {
      if (env.isEasyBikeApp) {
        return true;
      }
      return false;
    },
  },
  async mounted() {
    if (isPreRender()) {
      document.dispatchEvent(new Event('render-event'));
    } else {
      await this.getTask();
    }
  },
  methods: {
    async getTask() {
      if (!(await Native.isLogin())) {
        return;
      }
      const data = await getTokenAndLocation();
      const { adCode, cityCode, token } = data;
      const toPost = {
        token,
        systemCode: getSystemCode(),
        subSceneNameEn: 'zmgo_app',
        channelId: env.platformCode,
        adCode,
        cityCode,
        taskGroupCode: this.$route.query.taskGroupCode,
      };
      getZhiMaGoTask(toPost)
        .then((res) => {
          if (res && res.data) {
            const {
              title,
              finishTaskText,
              failTaskText,
              settlementStatus,
              zhimaCode,
              amount,
              failPrice,
              primeCost,
              taskList,
            } = res.data || {};
            Object.assign(this, {
              title,
              finishTaskText,
              failTaskText,
              settlementStatus,
              zhimaCode,
              amount,
              failPrice,
              primeCost,
              taskList,
            });
            this.mistiming(taskList || []);
            let taskStatus = '';
            if (this.taskList.length > 0) {
              taskStatus = this.taskList[0].taskStatus;
            } else {
              taskStatus = '';
            }
            UBT.pageView({
              pageId: 'platform_zhima',
              categoryId: 'platform',
              businessInfo: {
                settle_status: this.settlementStatus,
                task_status: taskStatus,
                taskcode: this.$route.query.taskGroupCode,
              },
            });
          }
        })
        .catch((e) => {
          Toast.show(e && e.message ? e.message : '请求任务数据失败');
        });
    },
    mistiming(taskList) {
      if (this.taskList.length < 1) return;
      const [data] = taskList;
      let timeStamp = data.expireCountdown;
      if (timeStamp > 0) {
        this.times = formateTimeStamp(timeStamp);
      }
      const TimeDown = setInterval(() => {
        if (timeStamp > 1) {
          timeStamp -= 1;
          this.times = formateTimeStamp(timeStamp);
        } else {
          clearInterval(TimeDown);
        }
      }, 1000);
    },
    end() {
      UBT.clickButton({
        pageId: 'platform_zhima',
        buttonName: 'zhimatask_over',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.$refs.outSesameGo.open({ taskGroupCode: this.$route.query.taskGroupCode });
    },
    back() {
      if (env.isEasyBikeApp) {
        Native.goBack();
      } else {
        this.$router.go(-1);
      }
    },
    // 做任务
    doTask() {
      if (this.taskList.length < 1) return;
      const [data] = this.taskList;
      UBT.clickButton({
        pageId: 'platform_zhima',
        buttonName: 'zhimatask_go',
        categoryId: 'platform',
        businessInfo: {},
      });
      window.location.href = data.taskUrl;
    },
    close() {},
    // 活动规则
    rule() {
      UBT.clickButton({
        pageId: 'platform_zhima',
        buttonName: 'zhima_rule',
        categoryId: 'platform',
        businessInfo: {},
      });
      commonGoLink('https://h.c3x.me/1Uszjs', { isRuleLink: true });
    },
    // 用户协议
    agreement() {
      UBT.clickButton({
        pageId: 'platform_zhima',
        buttonName: 'zhima_agreement',
        categoryId: 'platform',
        businessInfo: {},
      });
      commonGoLink('https://h.c3x.me/1VMpZd', { isRuleLink: true });
    },
    async endTask() {
      await this.getTask();
    },
  },
};
</script>

<style lang="less" scoped>
.sesame-go-container {
  height: 8.12rem;
  background: #f0f3f5;
  overflow-y: auto;
  position: relative;

  .operation .item span {
    font-size: 0.16rem;
    font-weight: 400;
    color: #242729;
  }

  .header-img {
    position: absolute;
    width: 100%;
    height: 2.57rem;
  }

  .header-alimp {
    top: -0.51rem;
  }

  .header {
    width: 100%;
    padding-left: 0.28rem;
    margin-bottom: 0.18rem;
    position: relative;

    .safe-area {
      padding-top: constant(safe-area-inset-top);
      padding-top: env(safe-area-inset-top);
      height: 0.4rem;
    }

    .back {
      width: 0.24rem;
      height: 0.24rem;
      margin-left: -0.16rem;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .task-status {
      margin-top: 0.26rem;
      height: 0.33rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #fff;
      line-height: 0.33rem;
    }

    .describe {
      margin-top: 0.06rem;
      display: flex;
      height: 0.24rem;
      line-height: 0.24rem;

      .surplus {
        font-size: 0.14rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.94);
        position: relative;
        top: 0.015rem;
      }

      .time {
        .time-box {
          display: inline-block;
          border-radius: 0.04rem;
          border: 0.01rem solid rgba(255, 255, 255, 0.6);
          box-sizing: content-box;
          background: rgba(255, 255, 255, 0.22);
          width: 0.24rem;
          height: 0.24rem;
          line-height: 0.24rem;
          font-size: 0.16rem;
          color: #fff;
          text-align: center;
          font-family: "DINAlternate", sans-serif;
          font-weight: medium;
        }

        span {
          font-size: 0.1rem;
          font-weight: 400;
          color: #fff;
          line-height: 0.14rem;
          display: inline-block;
          margin: 0 0.08rem 0 0.02rem;
          position: relative;
          top: 0.02rem;
        }
      }
    }
  }

  .task-info {
    width: 3.51rem;
    background: #fff;
    border-radius: 0.12rem;
    margin-left: 0.12rem;
    padding: 0.2rem 0.16rem 0.24rem;
    position: relative;

    .task,
    .discount,
    .progressed {
      display: flex;

      div:nth-child(1) {
        white-space: nowrap;
        height: 0.21rem;
        font-size: 0.15rem;
        font-weight: 400;
        color: #879099;
        line-height: 0.21rem;
        margin-right: 0.08rem;
      }

      div:nth-child(2) {
        font-size: 0.15rem;
        font-weight: 500;
        color: #242729;
        line-height: 0.21rem;
      }
    }

    .discount,
    .progressed {
      margin-top: 0.1rem;
    }

    .button {
      width: 3.19rem;
      height: 0.48rem;
      text-align: center;
      line-height: 0.48rem;
      background: #0c6afb linear-gradient(90deg, #0076ff 0%, #409eff 100%);
      border-radius: 0.08rem;
      font-size: 0.18rem;
      font-weight: 500;
      color: #fff;
      margin-top: 0.16rem;
    }
  }

  .content {
    width: 3.51rem;
    height: 1.68rem;
    background: #fff;
    border-radius: 0.12rem;
    margin: 0.12rem auto 0;

    .title {
      width: 2.13rem;
      height: 0.32rem;
      margin: 0 auto;
      background: url(https://m.hellobike.com/resource/helloyun/wb15250/K0NQ2sWHE3.png?x-oss-process=image/quality,q_80) no-repeat top;
      background-size: 100% 100%;
      font-size: 0.16rem;
      font-weight: 500;
      color: #242729;
      line-height: 0.32rem;
      text-align: center;
    }

    .promise {
      width: 3.03rem;
      height: 0.88rem;
      margin: 0.24rem auto;
      background: url(https://m.hellobike.com/resource/helloyun/wb15250/6pg3wqiYu1.png?x-oss-process=image/quality,q_80) no-repeat top;
      background-size: 100% 100%;
      display: flex;
      position: relative;

      .left,
      .right {
        position: absolute;
        color: #1b7afe;
        max-width: 0.98rem;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        .info-title {
          display: flex;

          .info {
            height: 0.2rem;
            font-size: 0.14rem;
            font-weight: 400;
            line-height: 0.2rem;
            margin-right: 0.02rem;
          }

          .icon {
            width: 0.3rem;
            height: 0.16rem;
            background: url(https://m.hellobike.com/resource/helloyun/wb15250/vcw-hF7uwH.png?x-oss-process=image/quality,q_80) no-repeat top;
            background-size: 100% 100%;
            margin-top: 0.02rem;
          }
        }

        .info-content {
          height: 0.22rem;
          font-size: 0.16rem;
          font-weight: 500;
          line-height: 0.22rem;
          margin-top: 0.04rem;
        }
      }

      .left {
        left: 0.16rem;
        top: 0.16rem;
      }

      .right {
        right: 0.16rem;
        top: 0.26rem;
        color: #fe6431;

        .info-title {
          justify-content: flex-end;

          .icon {
            background: url(https://m.hellobike.com/resource/helloyun/wb15250/OtGLNdoNUt.png?x-oss-process=image/quality,q_80) no-repeat top;
            background-size: 100% 100%;
          }
        }
      }
    }
  }

  .operation {
    width: 3.51rem;
    margin: 0.12rem auto;
    padding: 0 0.16rem 0 0.16rem;
    background-color: #fff;
    border-radius: 0.12rem;

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.52rem;
      line-height: 0.52rem;

      .symbol {
        width: 0.14rem;
        height: 0.14rem;
      }
    }

    .item:nth-child(2) {
      border-top: 1px solid #f0f3f5;
    }

    .bottom-border {
      border-bottom: 1px solid #f0f3f5;
    }
  }
}

</style>
